import getListing from "./get-listing.api";

const modulesApi = {
  getListing,
};

export default modulesApi;
